import type { FetchError } from 'ofetch'

export interface ReturnedErrorUseApiFetchType<T> {
    message: string
    errors: {
        [key in keyof T]?: string[]
    }
}
type ErrorState<T> = {
    [K in keyof T]: T[K] extends readonly unknown[]
        ? string
        : T[K] extends File | File[]
          ? string
          : T[K] extends object
            ? ErrorState<T[K]>
            : string | boolean
}
function setDeepError<T>(obj: ErrorState<T>, path: string, value: string) {
    const keys = path.split('.') as (keyof T | string)[]
    let current: any = obj
    for (let i = 0; i < keys.length - 1; i++) {
        if (!(keys[i] in current)) return // если структура неожиданная — выходим
        current = current[keys[i]]
    }

    const lastKey = keys[keys.length - 1]
    if (lastKey in current) {
        current[lastKey] = value
    }
}

export function errorHandling<T>(
    error: FetchError<ReturnedErrorUseApiFetchType<T>> | null,
    errorState: ErrorState<T> | null = null
) {
    // const toast = useToast()

    if (!error || !error.data) return

    if (!error.data.errors || Object.keys(error.data.errors).length === 0) {
        // toast.add({
        //     appearance: 'error',
        //     title: 'Ошибка',
        //     description: error.data.message,
        // })
    }

    Object.entries(error.data.errors).forEach(([key, messages]) => {
        const msg = (messages as string[])[0] ?? 'Ошибка'
        if (errorState) {
            if (key.includes('.')) {
                setDeepError(errorState, key, msg)
                return
            }
            if (key in errorState) {
                errorState[key as keyof T] = msg as ErrorState<T>[keyof T]
            } else {
                // toast.add({
                //     appearance: 'error',
                //     title: 'Ошибка',
                //     description: msg,
                // })
            }
        } else {
            // toast.add({
            //     appearance: 'error',
            //     title: 'Ошибка',
            //     description: msg,
            // })
        }
    })
}
